<script setup>
import { getI18n } from '@/plugins/i18n'
import { useVModel } from '@vueuse/core'

const i18n = getI18n()

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({ show: false, resources: [], onContinue: null }),
  },
})

const emit = defineEmits(['update:modelValue'])
const value = useVModel(props, 'modelValue', emit)
</script>
<template>
  <q-dialog v-model="value.show" persistent class="dialog-xxs">
    <q-card>
      <q-card-section class="row items-center no-wrap">
        <q-avatar
          icon="mdi-alert"
          color="warning"
          text-color="white"
          size="md"
        />
        <span class="q-ml-sm text-subtitle1">{{ i18n.t('common.insufficientStock') }}</span>
      </q-card-section>
      <q-card-section class="q-pt-none">
        <div>{{ i18n.t('warning.confirmNoStockServices') }}</div>
        <q-list dense class="q-mt-sm">
          <q-item v-for="(name, idx) in value.resources" :key="idx" dense>
            <q-item-section>{{ name }}</q-item-section>
          </q-item>
        </q-list>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn
          v-close-popup
          flat
          :label="i18n.t('common.cancel')"
        />
        <q-btn
          flat
          color="warning"
          :label="i18n.t('common.continue')"
          @click="value.onContinue?.()"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
